/* Midway (added by Claude). Loaded on every page from snippets/seo-title.liquid.
   1. Product page + quick add: tapping a color lands on an in-stock size of that color. Tapping a sold-out size
      keeps it selected (Sold out + "Notify me when it's back in stock" show). Same code is inline in snippets/variant-picker.liquid; the first one wins.
   2. Side cart "Complete Your Cart": sizes look like the product page (grey + crossed out when sold out,
      not clickable) and are greyed per selected color, not across all colors. */
(function () {
  if (window.mwVariantFix2) return;
  window.mwVariantFix2 = true;
  function colorIndex(product) {
    var idx = 0;
    (product.options || []).forEach(function (o, i) {
      var n = String(o && o.name ? o.name : o).toLowerCase();
      if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) idx = i;
    });
    return idx;
  }
  function sizeIndex(product) {
    var idx = -1;
    (product.options || []).forEach(function (o, i) {
      var n = String(o && o.name ? o.name : o).toLowerCase();
      if (n.indexOf('size') !== -1) idx = i;
    });
    return idx;
  }
  /* Remember which option the shopper just changed (size or color), so that one is kept */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.name || t.name.indexOf('option') !== 0 || !t.closest) return;
    var vp = t.closest('variant-picker');
    if (vp) vp._mwChanged = parseInt(t.name.slice(6), 10) - 1;
  }, true);
  customElements.whenDefined('variant-picker').then(function () {
    var P = customElements.get('variant-picker').prototype;
    if (P._mwPatched2) return;
    P._mwPatched2 = true;
    var orig = P.selectVariant;
    P.selectVariant = function (id) {
      if (!this._mwFirst) {
        this._mwFirst = true;
        /* Opened from "Notify me" (?notify=1): stay on the sold-out size so Omnisend can show its form */
        if (/[?&]notify=1/.test(window.location.search)) return orig.call(this, id);
      }
      try {
        var variants = (this.product && this.product.variants) || [];
        var v = variants.find(function (x) { return x.id === id; });
        var a = typeof this._mwChanged === 'number' && this._mwChanged >= 0 ? this._mwChanged : colorIndex(this.product);
        this._mwChanged = null;
        /* Shopper tapped a sold-out size: keep it, so they see Sold out + "Notify me when it's back in stock" */
        if (v && !v.available && a === sizeIndex(this.product)) return orig.call(this, id);
        if (!v || !v.available) {
          var opts = v ? v.options : this._getSelectedOptionValues();
          var best = null, score = -1;
          variants.forEach(function (x) {
            if (!x.available || x.options[a] !== opts[a]) return;
            var s = 0;
            x.options.forEach(function (val, i) { if (i !== a && val === opts[i]) s += 10 - i; });
            if (s > score) { score = s; best = x; }
          });
          if (best) id = best.id;
        }
      } catch (e) {}
      return orig.call(this, id);
    };
  });
})();

(function () {
  if (window.mwCycFix) return;
  window.mwCycFix = true;

  var css = '' +
    '#cart-drawer-recommendations .cyc-size-block { border: 1px solid #8f8a86 !important; border-radius: 0 !important; background: #fff !important; color: #221f20 !important; font-weight: 600 !important; }' +
    '#cart-drawer-recommendations .cyc-size-block:hover { border-color: #221f20 !important; }' +
    '#cart-drawer-recommendations .cyc-size-block.active { background: #221f20 !important; color: #fff !important; border-color: #221f20 !important; }' +
    '#cart-drawer-recommendations .cyc-size-block.disabled { background: #ebe7e3 !important; color: #a39d97 !important; border-color: #ebe7e3 !important; font-weight: 400 !important; text-decoration: line-through; text-decoration-color: rgba(34, 31, 32, .4); pointer-events: none !important; cursor: default !important; }' +
    '#cart-drawer-recommendations .cyc-size-block.disabled::after { display: none !important; }';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function sync(slide) {
    var state = window.__cycState;
    var product = state && state.productMap && state.productMap[slide.dataset.productId];
    if (!product || !product.variants) return;
    var colorSel = {};
    slide.querySelectorAll('.cyc-color-swatch.active').forEach(function (s) { colorSel[s.dataset.optionIndex] = s.dataset.value; });
    var groups = {};
    slide.querySelectorAll('.cyc-size-block').forEach(function (b) {
      (groups[b.dataset.optionIndex] = groups[b.dataset.optionIndex] || []).push(b);
    });
    Object.keys(groups).forEach(function (idx) {
      var i = parseInt(idx, 10);
      var ok = {};
      groups[idx].forEach(function (b) {
        if (ok[b.dataset.value] === undefined) {
          ok[b.dataset.value] = product.variants.some(function (v) {
            if (!v.available || v.options[i] !== b.dataset.value) return false;
            return Object.keys(colorSel).every(function (ci) { return v.options[ci] === colorSel[ci]; });
          });
        }
        b.classList.toggle('disabled', !ok[b.dataset.value]);
      });
      var active = groups[idx].find(function (b) { return b.classList.contains('active'); });
      if (active && active.classList.contains('disabled')) {
        var next = groups[idx].find(function (b) { return !b.classList.contains('disabled'); });
        groups[idx].forEach(function (b) { b.classList.toggle('active', !!next && b.dataset.value === next.dataset.value); });
      }
    });
    var sel = [];
    for (var k = 0; k < product.options.length; k++) {
      var a = slide.querySelector('.cyc-size-block.active[data-option-index="' + k + '"], .cyc-color-swatch.active[data-option-index="' + k + '"]');
      sel[k] = a ? a.dataset.value : null;
    }
    var variant = product.variants.find(function (v) { return v.options.every(function (o, j) { return sel[j] === null || o === sel[j]; }); });
    if (variant) {
      slide.dataset.variantId = variant.id;
      var btn = slide.querySelector('[data-add-btn]');
      if (btn) btn.disabled = !variant.available;
    }
  }

  document.addEventListener('click', function (e) {
    var hit = e.target.closest && e.target.closest('#cart-drawer-recommendations .cyc-color-swatch, #cart-drawer-recommendations .cyc-size-block');
    if (!hit) return;
    var slide = hit.closest('.cyc-slide');
    if (slide) setTimeout(function () { sync(slide); }, 0);
  });

  var queued = false;
  function scan() {
    queued = false;
    document.querySelectorAll('#cart-drawer-recommendations .cyc-size-blocks:not([data-mw-sync])').forEach(function (w) {
      w.setAttribute('data-mw-sync', '');
      var slide = w.closest('.cyc-slide');
      if (slide) sync(slide);
    });
  }
  function start() {
    new MutationObserver(function () {
      if (!queued) { queued = true; requestAnimationFrame(scan); }
    }).observe(document.body, { childList: true, subtree: true });
    scan();
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
